











import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ExpandablePanel extends Vue {
  @Prop({ required: true }) readonly name!: string

  private open = false;

  private toggleOpen() {
    this.open = !this.open;
  }
}
